var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.02 11.078 2.856 2.855-.943.943-2.855-2.855a5.97 5.97 0 0 1-3.745 1.312c-3.312 0-6-2.688-6-6s2.688-6 6-6a6.002 6.002 0 0 1 4.687 9.745m-1.337-.495a4.665 4.665 0 0 0-3.35-7.916 4.665 4.665 0 0 0-4.667 4.666 4.665 4.665 0 0 0 7.917 3.35z"
  })));
};
export default SvgSearch;